// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2fpbO","tab":"Tabs_tab__2dFht","tabActive":"Tabs_tabActive__1XK07"};